// extracted by mini-css-extract-plugin
export default {"bar":"WelcomeStepBar_bar__DFZCk","count":"WelcomeStepBar_count__bjHOs","label":"WelcomeStepBar_label__92kte","next":"WelcomeStepBar_next__DCTys","skip":"WelcomeStepBar_skip__CFDju"};